// src/components/ContactTypeStep.jsx
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import API from "../../util/api";
import { MEMBERSHIP_LABELS } from "../../util/constant";

const Section = styled.div`
  margin-bottom: 24px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
`;

const SectionHeader = styled.div`
  background: #195174;
  color: white;
  padding: 12px 16px;
  font-size: 1.2rem;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  td, th { padding: 12px 16px; vertical-align: top; }
  h2 { margin: 0 0 8px; color: #195174; }
  label { font-weight: bold; }
  small { color: #555; }
`;

const RadioLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  cursor: pointer;
  input { margin-right: 8px; }
`;

export default function ContactTypeStep({ data, onChange }) {
  const {
    first_name,
    last_name,
    street,
    street2,
    city,
    state,
    zip,
    phone,
    ext,
    fax,
    email,
    membership,
    contact_type
  } = data;

  const [options, setOptions]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setError(null);

    API.getContactType({ code: membership })
      .then(resp => {
        if (!isMounted) return;
        if (resp.status === "Success" && Array.isArray(resp.contact_types)) {
          setOptions(resp.contact_types);
        } else {
          setError(resp.message || "Failed to load contact types.");
        }
      })
      .catch(() => {
        if (isMounted) setError("Error fetching contact types.");
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [membership]);

  return (
    <Section>
      <SectionHeader>Review &amp; Contact Type</SectionHeader>
      <Table>
        <tbody>
          <tr>
            <th colSpan="2"><h2>Personal Info</h2></th>
          </tr>
          <tr>
            <td>Personal Info</td>
            <td>
              {first_name} {last_name}<br/>
              {street}<br/>
              {street2 && (<>{street2}<br/></>)}
              {city}, {state} {zip}<br/>
              {phone}{ext && ` ext. ${ext}`}<br/>
              {fax && `fax: ${fax}`}<br/>
              {email}
            </td>
          </tr>
          <tr>
            <td>Membership Type</td>
            <td>{MEMBERSHIP_LABELS[membership] || membership}</td>
          </tr>
          <tr>
            <td><label htmlFor="contact_type">Contact Type*</label></td>
            <td>
              {loading && <p>Loading contact types…</p>}
              {error   && <p style={{ color: "red" }}>{error}</p>}
              {!loading && !error && options?.map(opt => (
                <RadioLabel key={opt}>
                  <input
                    type="radio"
                    name="contact_type"
                    value={opt}
                    checked={contact_type === opt}
                    onChange={onChange}
                  />
                  {opt}
                </RadioLabel>
              ))}
            </td>
          </tr>
        </tbody>
      </Table>
    </Section>
  );
}
